export default "__VITE_ASSET__e8fc0af5__"